import axios from "axios";
import { baseURL } from "./constants";

const loginApi = async (email, password) => {
  try {
    return axios.post(`${baseURL}/auth/local`, { email: email, password });
  } catch (error) {
    throw error;
  }
};

const logoutApi = async (currentUser) => {
  try {
    return axios.post(`${baseURL}/auth/logout`, {},
      {
        headers: {
          Authorization: `Bearer ${currentUser?.jwt}`,
        },
      }
    );
  } catch (error) {
    throw error;
  }
};

const forgotPasswordApi = async (email) => {
  try {
    return axios.post(`${baseURL}/auth/forgot-password`, { email });
  } catch (error) {
    throw error;
  }
};

const resetPasswordApi = async ({ newPassword, confirmPassword, code }) => {
  try {
    return axios.post(`${baseURL}/auth/reset-password`, {
      password: newPassword,
      passwordConfirmation: confirmPassword,
      code,
    });
  } catch (error) {
    throw error;
  }
};

const resetPasswordCodeCheck = async (code) => {
  try {
    return axios.get(`${baseURL}/auth/code-link-valid`, {
      params: {
        code: code
      }
    });
  } catch (error) {
    throw error;
  }
};

const sendOtpApi = async (email) => {
  try {
    return axios.post(`${baseURL}/auth/send-otp`, { email });
  } catch (error) {
    throw error;
  }
};

const verifyOtpApi = async (email, otp) => {
  try {
    return axios.post(`${baseURL}/auth/verify-otp`, { email, otp });
  } catch (error) {
    throw error;
  }
};

const sendLoginLinkApi = async (email) => {
  try {
    return axios.post(`${baseURL}/auth/send-magic-link`, { email });
  } catch (error) {
    throw error;
  }
};

const verifyMagicLinkApi = async (token) => {
  try {
    return axios.get(`${baseURL}/auth/verify-magic-link`, {
      params: { token },
    });
  } catch (error) {
    throw error;
  }
};


export { loginApi, logoutApi, forgotPasswordApi, resetPasswordApi, resetPasswordCodeCheck, sendOtpApi, verifyOtpApi, sendLoginLinkApi, verifyMagicLinkApi };
